import { createSelector } from '@reduxjs/toolkit';
import { getControlUnitById } from '.';
import {
  getControlUnitCurrentEventsById,
  getMetadataControlUnitEventsFromId,
} from './events';
import { getCUActionsResponseByCUId } from '../../CUActions/selectors/CUActionsAPISelectors';
import { getDigitalEventValue } from '../../../redux/monitoring/api/util/mapDigitalEvent';

export const getActionsMetadataSelectorById = createSelector(
  [getControlUnitById],
  (controlUnit) => {
    return controlUnit?.actions;
  }
);

export const getActionExtendedSelectorById = createSelector(
  [
    getActionsMetadataSelectorById,
    getMetadataControlUnitEventsFromId,
    getControlUnitCurrentEventsById,
    getCUActionsResponseByCUId,
  ],
  (actionsMetadata, eventsMetadata, valueEvents, actionsCollectionResponse) => {
    return (
      actionsMetadata?.map((metadata) => {
        const event = valueEvents?.[metadata.id];
        const eventMetadata = eventsMetadata?.find(
          (event) => event.id === metadata.id
        );
        const { data: actionsCollection, ...restActionCollection } =
          actionsCollectionResponse;
        const actionCollection = {
          data: actionsCollection.find((action) => action.id === metadata.id),
          ...restActionCollection,
        };

        // Normalize timestamps for comparison (messageTimestamp is in seconds, event.timestamp in ms)
        const actionTs = actionCollection?.data?.messageTimestamp
          ? actionCollection.data.messageTimestamp * 1000
          : null;
        const eventTs = event?.timestamp ?? null;

        // Action has priority when timestamps are missing, equal, or action is newer
        const actionFirst = !actionTs || !eventTs || actionTs >= eventTs;

        const eventValue = event
          ? getDigitalEventValue(event?.value, eventMetadata)
          : undefined;

        const parsedValue = actionFirst
          ? actionCollection?.data?.value ?? eventValue ?? false
          : eventValue ?? actionCollection?.data?.value ?? false;

        return {
          value: parsedValue,
          event,
          eventMetadata,
          metadata,
          actionCollection,
        };
      }) ?? []
    );
  }
);

export type ActionExtendedValue = ReturnType<
  typeof getActionExtendedSelectorById
>[number];
